"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.scrollTo = exports.useScrollTo = void 0;
var framer_motion_1 = require("framer-motion");
var useScrollTo = function (transition) {
    var isStopped = false;
    var onWheel = function () {
        isStopped = true;
        window.removeEventListener('wheel', onWheel);
    };
    var scrollTo = function (target, offset) {
        if (offset === void 0) { offset = 0; }
        var y = 0;
        if (typeof target === 'number') {
            y = target;
        }
        else if (typeof target === 'string' || (target === null || target === void 0 ? void 0 : target.nodeType) === 1) {
            if (typeof target === 'string') {
                target = document.querySelector(target);
            }
            if (!target) {
                console.error('framer-motion-scroll-to-hook: Element not found');
            }
            else {
                y = window.scrollY + target.getBoundingClientRect().top;
            }
        }
        y += offset;
        window.addEventListener('wheel', onWheel);
        (0, framer_motion_1.animate)(window.scrollY, y, __assign(__assign({}, transition), { onComplete: function () {
                isStopped = false;
                window.removeEventListener('wheel', onWheel);
            }, onUpdate: function (value) {
                if (!isStopped) {
                    window.scroll(0, value);
                }
            } }));
    };
    return scrollTo;
};
exports.useScrollTo = useScrollTo;
var scrollTo = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.scroller, scroller = _c === void 0 ? window : _c, transition = _b.transition, target = _b.target, _d = _b.offset, offset = _d === void 0 ? 0 : _d;
    return __awaiter(void 0, void 0, void 0, function () {
        var isStopped, onWheel, isScrollerWindow, scrollY, y, animate;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    if (typeof window === 'undefined' || !scroller) {
                        return [2 /*return*/];
                    }
                    isStopped = false;
                    onWheel = function () {
                        isStopped = true;
                        scroller.removeEventListener('wheel', onWheel);
                    };
                    isScrollerWindow = 'scrollY' in scroller;
                    scrollY = isScrollerWindow ? scroller.scrollY : scroller.scrollTop;
                    y = 0;
                    if (typeof target === 'number') {
                        y = target;
                    }
                    else if (typeof target === 'string' || (target === null || target === void 0 ? void 0 : target.nodeType) === 1) {
                        if (typeof target === 'string') {
                            target = document.querySelector(target);
                        }
                        if (!target) {
                            console.error('Element not found');
                        }
                        else {
                            y = isScrollerWindow ? scrollY + target.getBoundingClientRect().top : target.offsetTop;
                        }
                    }
                    y += offset;
                    scroller.addEventListener('wheel', onWheel);
                    return [4 /*yield*/, Promise.resolve().then(function () { return require('framer-motion'); })];
                case 1:
                    animate = (_e.sent()).animate;
                    animate(scrollY, y, __assign(__assign({}, transition), { onComplete: function () {
                            isStopped = false;
                            scroller.removeEventListener('wheel', onWheel);
                        }, onUpdate: function (value) {
                            if (!isStopped) {
                                scroller.scroll(0, value);
                            }
                        } }));
                    return [2 /*return*/];
            }
        });
    });
};
exports.scrollTo = scrollTo;
